import { Conference, ConferenceType } from 'types/models/Conference';
import CalendarBoldIcon from 'assets/icons/calendar-bold.svg';
import HeadphoneBoldIcon from 'assets/icons/headphone-bold.svg';
import LockIcon from 'assets/icons/last-watched.svg';
import MapPinIcon from 'assets/icons/map-pin.svg';
import Typography from '@components/atoms/Typography';
import { FormattedMessage, MessageDescriptor, useIntl } from 'utils/intl';
import formatDateRange from 'utils/formatDateRange';

import classes from './ConferenceInfo.module.scss';
import messages from './ConferenceInfo.messages';

type Props = Pick<Conference, 'type' | 'dateFrom' | 'dateTo' | 'location' | 'isPrivate'> & {
  variant?: 'small' | 'big';
};

const freeMessageMap: Record<ConferenceType['id'], MessageDescriptor> = {
  REMOTE: messages.freeRemote,
  STATIONARY: messages.freeStationary,
};

const ConferenceInfo = ({ type, dateFrom, dateTo, location, isPrivate, variant = 'big' }: Props) => {
  const intl = useIntl();
  const TypeIcon = type.id === 'REMOTE' ? HeadphoneBoldIcon : MapPinIcon;
  const isSmall = variant === 'small';

  return isSmall ? (
    <Typography variant="body2" renderAs="div" className={classes.wrapper}>
      {[
        intl.formatMessage(freeMessageMap[type.id]),
        formatDateRange(dateFrom, dateTo),
        type.id === 'REMOTE' ? type.name : location.name,
      ].join(', ')}
    </Typography>
  ) : (
    <Typography variant="body1" renderAs="div" className={classes.bigWrapper}>
      <FormattedMessage tagName="span" {...freeMessageMap[type.id]} />
      <div className={classes.box}>
        <CalendarBoldIcon width={20} height={20} />
        <span>{formatDateRange(dateFrom, dateTo)}</span>
      </div>
      <div className={classes.box}>
        <TypeIcon width={20} height={20} />
        <span>{type.id === 'REMOTE' ? type.name : location.name}</span>
      </div>
      {isPrivate && (
        <div className={classes.box}>
          <LockIcon width={26} height={26} />
          <FormattedMessage {...messages.privateConference} />
        </div>
      )}
    </Typography>
  );
};

export default ConferenceInfo;
